import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type LanguageDataType = {
  id: number;
  code: string;
  image: string;
  is_visible: boolean;
  name: string;
};

type LanguageState = {
  selectedLanguage: LanguageDataType | null;
};

const initialState: LanguageState = {
  selectedLanguage: null,
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<LanguageDataType>) => {
      state.selectedLanguage = action.payload;
      localStorage.setItem("bsc-lang", action.payload.code);
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
